import Button from '@admin/components/button'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import Chooser from './chooser'
import React from 'react'

class PropertyField extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    defaultValue: PropTypes.string,
    properties: PropTypes.array,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    property: null
  }

  _handleChoose = this._handleChoose.bind(this)
  _handleClear = this._handleClear.bind(this)
  _handleLookup = this._handleLookup.bind(this)

  render() {
    const { property } = this.state
    return (
      <div className="maha-input">
        <div className="maha-input-field" onClick={ this._handleLookup }>
          { property ?
            <div className="maha-input-token">
              <T text={ property.label } />
            </div> :
            <div className="maha-input-placeholder">
              <T text="t(Choose a property)" />
            </div>
          }
        </div>
        { property &&
          <Button { ...this._getClear() } />
        }
      </div>
    )
  }

  componentDidMount() {
    const { defaultValue } = this.props
    if(defaultValue) {
      this.setState({
        property: this._getProperty(defaultValue)
      })
    }
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { property } = this.state
    if(!_.isEqual(property, prevState.property)) {
      this.props.onChange(property ? property.name : null)
    }
  }

  _getChooser() {
    const { properties } = this.props
    return {
      properties,
      onChoose: this._handleChoose
    }
  }

  _getClear() {
    return {
      svg: 'x',
      className: 'maha-input-action',
      handler: this._handleClear
    }
  }

  _getProperty(name) {
    const { properties } = this.props
    return properties.reduce((fields, group) => [
      ...fields,
      ...group.fields
    ], []).find(field => {
      return field.name === name
    })
  }

  _handleChoose(property) {
    this.setState({ property })
  }

  _handleClear() {
    this.setState({
      property: null
    })
  }

  _handleLookup() {
    this.context.form.push(Chooser, this._getChooser())
  }

}

export default PropertyField
